import _ from 'lodash'
import Background from './Background'
import Wood from './Wood'
import WoodBackground from './WoodBackground'
import Park from './Park'
import RoadMinor from './RoadMinor'
import RoadMajor from './RoadMajor'
import RoadPrimary from './RoadPrimary'
import RoadMajorLabel from './RoadMajorLabel'
import RoadMinorLabel from './RoadMinorLabel'
import Building from './Building'
import Water from './Water'
import River from './River'
import HistoricalMap from './HistoricalMap'
import BoundsBorder from './BoundsBorder'
import Places from './Places'
import BoundsFill from './BoundsFill'
import Relations from './Relations'
// import Colorize from './Colorize'

/**
 * Checks if relations and a historical map are switched on/off
 * and return a Mapbox style
 */
export default (relations, map, active) => {
  const showMap = !!map
  const layerSet = [
    [Background, true],
    [WoodBackground, active],
    [Wood, active],
    [Park, active],
    [Building, active],
    [RoadMinor, active],
    [RoadMinorLabel, active],
    [Water, active],
    [BoundsFill, active & showMap],
    [RoadMajor, true],
    [RoadPrimary, active],
    [HistoricalMap(map), active & showMap],
    [BoundsBorder, active & showMap],
    [River, true],
    [RoadMajorLabel, active],
    [Places, active],
    [Relations, relations],
    // [Colorize, !active],
  ]
  return _.flatten(
    _.compact(layerSet.map(([layer, use]) => (use ? layer : null)))
  )
}
